export const getBlogPublishDate = (blog) =>
  blog?.future_post_date || blog?.created_at || blog?.created_date || null;

export const getBlogPublishTimestamp = (blog) => {
  const timestamp = Date.parse(getBlogPublishDate(blog) || '');
  return Number.isNaN(timestamp) ? 0 : timestamp;
};

export const getBlogPublishDateIso = (blog) => {
  const timestamp = getBlogPublishTimestamp(blog);
  return timestamp ? new Date(timestamp).toISOString() : null;
};

export const getBlogModifiedDateIso = (blog) => {
  const publishTimestamp = getBlogPublishTimestamp(blog);
  const updatedTimestamp = Date.parse(blog?.updated_at || blog?.updatedAt || '');
  const timestamp = Math.max(publishTimestamp, Number.isNaN(updatedTimestamp) ? 0 : updatedTimestamp);
  return timestamp ? new Date(timestamp).toISOString() : null;
};

export const formatBlogPublishDate = (blog, options = {}) => {
  const timestamp = getBlogPublishTimestamp(blog);
  if (!timestamp) return '';

  return new Date(timestamp).toLocaleDateString('en-US', {
    year: 'numeric',
    month: 'long',
    day: 'numeric',
    ...options,
    timeZone: 'UTC',
  });
};

export const isBlogPublished = (blog, now = Date.now()) => {
  if (!blog?.future_post_date) return true;
  const scheduledTimestamp = Date.parse(blog.future_post_date);
  return !Number.isNaN(scheduledTimestamp) && scheduledTimestamp <= now;
};
